import type * as React from 'react';
import { Responsive } from '@cian/ui-kit';
import { LayoutsWidgetDesktop } from '../LayoutsWidgetDesktop';
import { LayoutsWidgetMobile } from '../LayoutsWidgetMobile';

export const LayoutsWidget = (): React.JSX.Element => {
  return (
    <>
      <Responsive desktop>
        <LayoutsWidgetDesktop />
      </Responsive>
      <Responsive phone tablet>
        <LayoutsWidgetMobile />
      </Responsive>
    </>
  );
};
